import { times, uniqueId } from 'lodash';

import { PaginationConfig } from './types';

export const getPaginationCount = (pagConfig?: PaginationConfig) => {
  const { total = 0, pageSize = 20, pageNumber = 1 } = pagConfig || {};

  if (!total) {
    return '';
  }

  const countTop = pageNumber * pageSize;

  return `${(pageNumber - 1) * pageSize + 1} - ${
    countTop > total ? total : countTop
  } of ${total}`;
};

export const getSkeletonCount = (length: number) =>
  times(length, () => uniqueId('list_skeleton_'));
